<template>
  <div class="OverView" style="display: flex">
    <div class="Left" style="width: 30%;height: 100%;" v-loading="loading">
      <div class="Export" style="display: flex;align-items: center;height:10%;margin-left: 30px;   user-select:none;justify-content: space-between" @click="ExportFile">
        <div class="BTN" style="margin-top: 10px;  width: 100%">
          <div style="padding: 30px;border: solid;border-color: #21a8a8;border-radius: 10px;align-items: center;text-align: center;transition: all 0.3s ease;  ">
            <h1 style="color: white;font-size: 25px">导出故障率表</h1>
          </div>
        </div>
      </div>
      <div class="LUper" style="display: flex;align-items: center;height:20%;margin-left: 30px;justify-content: space-between">

        <div class="leftbox" style="margin-top: 10px;width: 45%  ">
            <div style="padding: 30px;border: solid;border-color: #21a8a8;border-radius: 10px;align-items: center;text-align: center  ">
                <h1 style="color: white;font-size: 25px">检测设备数量</h1>
                <h1 style="color: #e6a23c" >{{ EuipmentNum }} 台</h1>
            </div>
        </div>
        <div class="rightbox" style="margin-top: 10px;width: 45%  ">
          <div style="padding: 30px;border: solid;border-color: #21a8a8;border-radius: 10px;align-items: center;text-align: center  ">

            <h1 style="color: white;font-size: 25px">检测用户数量</h1>
            <h1 style="color: #e6a23c" >{{ UserNum }} 个</h1>

          </div>
        </div>
      </div>
      <div class="LMid" style="align-items: center;height: 30%;margin-left: 30px">
        <div style="padding: 30px;border: solid;border-color: #21a8a8;border-radius: 10px;align-items: center;text-align: center  ">
          <div class="item1">
            <h1 style="color: white;font-size: 25px">测点数量</h1>
            <h1 style="color: #e6a23c" >{{PointNum}} 个</h1>
          </div>
          <div class="item1">
            <h1 style="color: white;font-size: 25px">正常测点数量</h1>
            <h1 style="color: #e6a23c" >{{NormalPointNum}} 个</h1>
          </div>
          <div class="item1">
            <h1 style="color: white;font-size: 25px">正常占比</h1>
            <h1 style="color: #e6a23c" >{{Percent}} %</h1>
          </div>
        </div>
      </div>
      <div ref="target" class="LBottom" style="display: flex;height: 30%;border: solid;border-color: #21a8a8;border-radius: 10px;margin-left: 30px;margin-top: 50px">
        <div
            ref="BarGraph"
            id="BarGraph"
            style="height: 80%;width: 100%;display: flex;margin-top: 20px"
        ></div>
      </div>

    </div>
    <div class="right" style="width: 70%;height: 100%;   ">
      <div class="RUper" style="height: 40%;margin-left: 100px">
        <div class="Float" style="position: absolute;margin-top: 10px;right: 150px;z-index: 10">
          <div style="color: white;font-size: 12px" >时间选择</div>
          <div>
            <el-date-picker
                v-model="dateRange"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                range-separator=""
                format="YYYY/MM/DD"
                class="timeSelector"
                @change="updateEchart"
                value-format="YYYY-MM-DD"
                unlink-panels
            ></el-date-picker>
          </div>
        </div>
        <div
            ref="LineGraph"
            id="LineGraph"
            style="height: 100%;width: 100%;display: flex;"
        ></div>
      </div>
      <div class="Rlower">
        <img src="~@/assets/china.png" style="background-size: cover;width: 60%;height: 60%;margin-left: 250px;">
      </div>

    </div>
  </div>
</template>

<script>
import {ref, onBeforeMount ,onBeforeUnmount, computed,onMounted, onUpdated, watch,router,nextTick,h,watchEffect} from 'vue'
import { ElMessageBox, ElLoading ,ElMessage} from 'element-plus'
import {useStore} from 'vuex'
import {useRoute, useRouter} from 'vue-router'
import axios from 'axios'
import {getAxios} from "/src/js/axios";
import mydark from "/static/halloween.json";
import * as echarts from "echarts";
export default {
  name: 'OverView',
  components:{

  },
  setup(props, ctx){
    const target = ref(null); // 创建一个 ref 来引用 DOM 元素
    const { cancel, token } = axios.CancelToken.source();
    let loading = ref(0);
    let PointNum = ref(0);
    let ErrorPointNum = ref(0);
    let NormalPointNum =  ref(0);
    let Percent = ref(0.0);
    let EuipmentNum = ref(0);
    let UserNum = ref(0);

    let store = useStore();
    let tmpTableData = ref([]);
    let myChart=ref({});
    let myChart1 = ref({});
    const data = [0,0,0,0];
    const dateRange = ref('')
    let timestamp = [];
    let errorRate = [];
    let offErrorRate = [];
    let onErrorRate = [];
    let valueErrorRate = [];
    let rawerrorRate= [];
    let rawoffErrorRate = [];
    let rawonErrorRate = [];
    let rawValueErrorRate = [];
    let option1 = {
      title: {
        text: '故障率趋势',
        textStyle: {
          color: "white",
        },
        left:'5%',
        top:'5%'
      },
      tooltip: {
        trigger: 'axis',
        formatter: function(params) {
          let tooltipContent = '';
          params.forEach(item => {
            tooltipContent += `${item.seriesName}: ${item.data}<br/>`;
          });
          return tooltipContent;
        }
      },

      legend: {
        data: ['总故障率','有线时间戳不更新故障率','无线时间戳不更新故障率','无线特征值不更新故障率'],
        textStyle: {
          color: '#fffff', // 图例名称的颜色
          fontSize: 14,   // 图例名称的字体大小
          fontWeight: 'bold',  // 图例名称的字体粗细
        },
        x:"center",
        y:"bottom",
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        axisLabel: {
          textStyle:{
            color:"#ffffff",
            fontSize: 8
          },
          interval: 0, // 横轴信息全部显示
          rotate: 0, // -30度角倾斜显示
          formatter: function (value) {
            const date = new Date(value);
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}年${month}月${day}日`; // 格式化为 YYYY-MM-DD

          }
        },
        min: 'dataMin', // x轴最小值设置为数据最小值
        max: 'dataMax', // x轴最大值设置为数据最大值
        boundaryGap: false, // 关闭时间轴两端的留白
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          textStyle: {
            color: "#ffffff"
          },
        },
        splitLine: {
          lineStyle: {
            color: "#21a8a8"
          }
        }

      },
      series: [
        {
          name: '总故障率',
          type: 'line',
          data: errorRate
        },
        {
          name: '有线时间戳不更新故障率',
          type: 'line',
          data: onErrorRate
        },
        {
          name: '无线时间戳不更新故障率',
          type: 'line',
          data: offErrorRate
        },
        {
          name: '无线特征值不更新故障率',
          type: 'line',
          data: valueErrorRate
        },
      ]
    };


    let option = {
      xAxis: {
        max: 'dataMax',
        splitLine:{
          show: false
        },
        axisLabel: {//x轴文字的配置
          show: true,
          textStyle: {
            color: "white",
          }
        }
      },
      grid: {
        left:"20%",
        top:"20%",
        bottom:"20%",
        right:"20%"
      },
      yAxis: {
        type: 'category',
        splitLine:{
          show: false
        },
        axisLabel: {//x轴文字的配置
          show: true,
          textStyle: {
            color: "white",
          }
        },
        data: ['无线机泵', '有线机泵', '大型旋转设备', '往复设备'],
        inverse: true,
        animationDuration: 300,
        animationDurationUpdate: 300,
      },
      series: [
        {
          name: '设备概览',

          type: 'bar',
          data: data,
          label: {
            show: true,
            position: 'right',
            valueAnimation: true
          }
        }
      ],
      legend: {
        show: true,
        textStyle: {
          color: 'white'
        },
      }
    };
    let ExportFile = (() => {
      let url = '/api1/Overview/exportExcel';
      let info = store.state.nodeData;

      for (let i = 0; i < 5; i++) {
        url += '/' + encodeURIComponent(info.node[i]).replace('%2F', '%252f');
      }
      let [start, end]=[1,1];
      console.log(dateRange);
      if (dateRange.value.length !== 0)  [start, end] = dateRange.value;;


      url += '/' + localStorage.getItem("username")+'/'+start+'/'+end;
      loading.value = 1;
      console.log(url)
      // 使用 axios 获取文件数据
      axios.get(url, {
        responseType: 'blob', // 使返回的数据格式为 Blob
        cancelToken: token
      }).then(res => {
        // 创建一个临时的 URL 对象指向返回的 Blob 数据
        const blob = new Blob([res.data]);
        const downloadUrl = window.URL.createObjectURL(blob);

        // 创建一个临时的 <a> 元素用于下载
        const link = document.createElement('a');
        link.href = downloadUrl;
        if(dateRange.value.length !== 0)
        {
          link.download = start+"至"+end+"有线测点错误率.xlsx"; // 设置默认的文件名
        }
        else {
          link.download = "全部有线测点错误率.xlsx"; // 设置默认的文件名
        }
        document.body.appendChild(link);
        link.click();

        // 清理操作
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        loading.value = 0;
      }).catch(error => {
        console.error("文件下载失败:", error);
        loading.value = 0;
      });
    });


    let DrawGraph=(()=>{
      console.log("开始画图")
      echarts.registerTheme("mydark",mydark);
      myChart = echarts.init(document.getElementById("BarGraph"));
      myChart1 = echarts.init(document.getElementById("LineGraph"));
      myChart.setOption(option);

      option1.series[0].data = errorRate;
      option1.series[1].data = onErrorRate;
      option1.series[2].data = offErrorRate;
      option1.series[3].data = valueErrorRate;
      myChart1.setOption(option1);
      nextTick(()=>{
        myChart.resize();
        myChart1.resize();
      })

    })
    // let updateEchart=(()=>{
    //   console.log(dateRange)
    //   if (dateRange.value.length === 0) return;
    //
    //   const [start, end] = dateRange.value;
    //   const filteredData = errorRate.filter(item => {
    //     const date = new Date(item[0]);
    //     return date >= new Date(start) && date <= new Date(end);
    //   });
    //   console.log(filteredData)
    //
    //   errorRate = filteredData;
    //   DrawGraph();
    //
    //
    // })
    let updateEchart = (() => {
      console.log(dateRange);
      if(dateRange.value == null)
      {
        errorRate = rawerrorRate;
        onErrorRate = rawonErrorRate;
        offErrorRate = rawoffErrorRate;
        valueErrorRate = rawValueErrorRate;
        DrawGraph();
      }
      // if (dateRange.value.length === 0) return;

      const [start, end] = dateRange.value;

      // 过滤 errorRate 数据
      const filteredErrorRate = rawerrorRate.filter(item => {
        const date = new Date(item[0]);
        return date >= new Date(start) && date <= new Date(end);
      });

      // 过滤 onErrorRate 数据
      const filteredOnErrorRate = rawonErrorRate.filter(item => {
        const date = new Date(item[0]);
        return date >= new Date(start) && date <= new Date(end);
      });

      // 过滤 offErrorRate 数据
      const filteredOffErrorRate = rawoffErrorRate.filter(item => {
        const date = new Date(item[0]);
        return date >= new Date(start) && date <= new Date(end);
      });

      // 过滤 valueErrorRate 数据
      const filteredValueErrorRate = rawValueErrorRate.filter(item => {
        const date = new Date(item[0]);
        return date >= new Date(start) && date <= new Date(end);
      });

      // 更新过滤后的数据
      errorRate = filteredErrorRate;
      onErrorRate = filteredOnErrorRate;
      offErrorRate = filteredOffErrorRate;
      valueErrorRate = filteredValueErrorRate;

      // 重新绘制图表
      DrawGraph();
    });
    let ResizeGraph = (()=>{
      myChart.resize();
      myChart1.resize();
    })
    window.onresize =  function (){
      myChart.resize()
      myChart1.resize();
    }


    let getAllStateNumber =  () => {       ///获取状态的数量
      let info = store.state.nodeData
      let url = '/api1/Overview/getDataByNode';
      // if(info.node[2]!=="empty"||info.node[4]!=="empty"||info.node[3]!=="empty")
      // {
      //   return
      // }

      for (let i = 0; i < 5; i++) {
        // url += '/'+info.node[i]
        url += '/' + encodeURIComponent(info.node[i]).replace('%2F', '%252f');
      }
      url += '/'+ localStorage.getItem("username");
      console.log(info);
      loading.value = 1;
      axios.get(url
          ,{
            cancelToken: token
          }
      ).then(res=>{
        console.log(res.data);
        UserNum.value = res.data.userNum;
        Percent.value = res.data.normalPercent.toFixed(2);
        PointNum.value = res.data.pointNum;
        ErrorPointNum.value =  res.data.normalPointNum;
        NormalPointNum.value = res.data.normalPointNum;
        EuipmentNum.value = res.data.equipmentNum;
        data[0] = res.data.wuxianjibeng ;
        data[1] =  res.data.youxianjibeng;
        data[2] = res.data.daxingxuanzhuan;
        data[3] = res.data.wangfushebei;
        timestamp= res.data.timeStampList;
        errorRate = [];
        offErrorRate = [];
        valueErrorRate = [];
        onErrorRate = [];
        for (let i = 0; i < res.data.errorRateHis.length; i++) {
          errorRate.push(res.data.errorRateHis[i]);
        }
        for (let i = 0;i< res.data.offErrorRateHis.length;i++)
        {
          offErrorRate.push(res.data.offErrorRateHis[i]);
        }
        for(let i = 0;i<res.data.valueErrorRateHis.length;i++)
        {
          valueErrorRate.push(res.data.valueErrorRateHis[i]);
        }
        for(let i = 0;i<res.data.onErrorRateHis.length;i++)
        {
          onErrorRate.push(res.data.onErrorRateHis[i]);
        }
        rawerrorRate = errorRate;
        rawValueErrorRate = valueErrorRate;
        rawoffErrorRate = offErrorRate;
        rawonErrorRate = onErrorRate;
        DrawGraph();
        loading.value = 0;
      }) .catch(err=>{
        localStorage.getItem("username")
        console.log(err)
      })

    }

    watch(() => store.state.nodeLable, () => {
      console.log('点击了设备树');
      // cancel('取消上一次请求')
      loading.value = 0;

      getAllStateNumber()
      DrawGraph();
      myChart.resize();
      myChart1.resize();
      return ;
    })


    onMounted(() => {

      // window.addEventListener("resize",handleClick)
      nextTick(()=>{
        DrawGraph();
        myChart.resize();
        myChart1.resize();
        console.log("调整窗口成功1");
      })

      getAllStateNumber();
    })


    let handleClick = (() => {
      console.log('点击按钮');
      myChart.resize();
      myChart1.resize();
    })
    onBeforeUnmount(()=>{
    })
    return {
      handleClick,
      UserNum,
      Percent,
      PointNum,
      ErrorPointNum,
      NormalPointNum,
      EuipmentNum,
      myChart,
      myChart1,
      DrawGraph,
      updateEchart,
      ResizeGraph,
      ExportFile,
      dateRange,
      getAllStateNumber,
      loading
    }
  },
}
</script>

<style lang="scss">
.OverView {
  //width: calc(100% - v-bind(treeWidth));
  width: 100%;
  margin-right: 10px;
  height: calc(100vh - 70px);
  margin-bottom: 10px;
  background-color: #303749;
}
.timeSelector{
  background-color: #303749 !important;
  height: 28px !important;
  width:230px !important;
  ::-webkit-input-placeholder{
    color: #ffffff !important;
  }

  .el-range-input{
    color: white !important;
    background-color: #303749 !important;
  }

  .el-input__inner{
    border-color: #3a9f93 !important;
  }
}
.BTN div {
  transition: all 0.3s ease;
}

.BTN div:hover {
  border-color: #00ffff; /* 悬停时边框发亮的颜色 */
  box-shadow: 0 0 10px #00ffff; /* 悬停时的发光效果 */
}

.BTN:active div {
  transform: translateY(2px); /* 点击时的下沉效果 */
}

  // background-color: #bfa;


</style>
